/* SoulMatesly Theme — theme.js */
(function () {
  'use strict';

  var theme = window.theme || {};
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------------------------------------------------------------- Utils */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || theme.moneyFormat || '₹{{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelims(n, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(n) || n == null) return 0;
      n = (n / 100.0).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var match = format.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelims(cents, 2); break;
      case 'amount_no_decimals': value = withDelims(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelims(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = withDelims(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = withDelims(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = withDelims(cents, 2, ' ', '.'); break;
      default: value = withDelims(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  var toastTimer;
  function toast(message, isError) {
    var el = $('[data-toast]');
    if (!el) return;
    el.innerHTML = (isError ? '' : '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>') + '<span></span>';
    el.querySelector('span').textContent = message;
    el.classList.toggle('toast--error', !!isError);
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3200);
  }

  /* ------------------------------------------------------- Drawers/overlay */
  var overlay = $('[data-overlay]');
  var openDrawerEl = null;
  var lastFocus = null;

  function openDrawer(drawer) {
    if (!drawer) return;
    if (openDrawerEl && openDrawerEl !== drawer) closeDrawer(openDrawerEl, true);
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.hidden = false;
    document.body.classList.add('no-scroll');
    openDrawerEl = drawer;
    setTimeout(function () { drawer.focus(); }, 50);
  }
  function closeDrawer(drawer, keepOverlay) {
    drawer = drawer || openDrawerEl;
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    openDrawerEl = null;
    if (!keepOverlay) {
      overlay.hidden = true;
      document.body.classList.remove('no-scroll');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(document.getElementById(opener.getAttribute('data-drawer-open')));
      return;
    }
    if (e.target.closest('[data-drawer-close]')) {
      closeDrawer(e.target.closest('[data-drawer]'));
      return;
    }
    if (e.target.closest('[data-overlay]')) {
      closeDrawer();
      closeSearch();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeDrawer();
    closeSearch();
    closeModals();
    var lb = $('[data-lightbox]:not([hidden])');
    if (lb) lb.hidden = true;
  });

  /* ---------------------------------------------------------------- Header */
  // The header section is sticky with its own z-index, which traps the mobile
  // menu drawer beneath the page overlay. Move the drawer to <body> instead.
  function hoistMenuDrawer() {
    var drawer = $('.section-site-header #MenuDrawer');
    if (!drawer) return;
    $$('body > #MenuDrawer').forEach(function (old) { old.remove(); });
    document.body.appendChild(drawer);
  }

  function initHeader() {
    hoistMenuDrawer();
    var header = $('[data-header]');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    var h = header.offsetHeight;
    if (h) document.documentElement.style.setProperty('--header-h', h + 'px');
  }

  /* ------------------------------------------------------- Announcement bar */
  function initAnnouncement() {
    $$('[data-announcement]').forEach(function (bar) {
      var msgs = $$('.announcement__msg', bar);
      if (msgs.length < 2) return;
      var i = 0;
      var speed = (parseInt(bar.dataset.speed, 10) || 4) * 1000;
      function go(next) {
        var cur = msgs[i];
        cur.classList.remove('is-active');
        cur.classList.add('is-leaving');
        setTimeout(function () { cur.classList.remove('is-leaving'); }, 600);
        i = (next + msgs.length) % msgs.length;
        msgs[i].classList.add('is-active');
      }
      var timer = setInterval(function () { go(i + 1); }, speed);
      function reset() { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, speed); }
      var prev = $('[data-ann-prev]', bar), next = $('[data-ann-next]', bar);
      if (prev) prev.addEventListener('click', function () { go(i - 1); reset(); });
      if (next) next.addEventListener('click', function () { go(i + 1); reset(); });
    });
  }

  /* ---------------------------------------------------------------- Search */
  var searchModal = $('[data-search-modal]');
  function openSearch() {
    if (!searchModal) return;
    searchModal.hidden = false;
    overlay.hidden = false;
    var input = $('[data-predictive-input]', searchModal);
    setTimeout(function () { input && input.focus(); }, 60);
  }
  function closeSearch() {
    if (!searchModal || searchModal.hidden) return;
    searchModal.hidden = true;
    if (!openDrawerEl) { overlay.hidden = true; document.body.classList.remove('no-scroll'); }
  }
  function initSearch() {
    $$('[data-search-open]').forEach(function (b) { b.addEventListener('click', openSearch); });
    $$('[data-search-close]').forEach(function (b) { b.addEventListener('click', closeSearch); });
    var input = $('[data-predictive-input]');
    var results = $('[data-predictive-results]');
    if (!input || !results) return;
    var controller;
    input.addEventListener('input', debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      var url = theme.routes.predictiveSearch + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,query,page,article&resources[limit]=6&section_id=predictive-search';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var res = doc.querySelector('#PredictiveSearchResults');
          results.innerHTML = res ? res.outerHTML : '';
        })
        .catch(function () {});
    }, 280));
  }

  /* ------------------------------------------------------------------ Cart */
  var cartDrawer = $('[data-cart-drawer]');

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
      el.classList.remove('bump');
      void el.offsetWidth;
      el.classList.add('bump');
    });
  }

  function renderCartDrawer(html) {
    if (!html || !cartDrawer) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('#CartDrawerInner');
    var current = $('#CartDrawerInner');
    if (fresh && current) {
      current.replaceWith(fresh);
      updateCartCount(parseInt(fresh.dataset.cartCountValue, 10) || 0);
    }
  }

  function refreshCartDrawer() {
    return fetch(theme.routes.root + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(renderCartDrawer);
  }

  function openCart() {
    if (theme.cartType === 'page' || !cartDrawer) {
      window.location.href = theme.routes.cart;
      return;
    }
    openDrawer(cartDrawer);
  }

  function addToCart(formData, button) {
    if (button) { button.classList.add('is-loading'); button.disabled = true; }
    formData.append('sections', 'cart-drawer');
    formData.append('sections_url', window.location.pathname);
    return fetch(theme.routes.cartAdd, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status && data.status !== 200) {
          throw new Error(data.description || data.message || theme.strings.error);
        }
        if (theme.cartType === 'page') {
          window.location.href = theme.routes.cart;
          return;
        }
        if (data.sections && data.sections['cart-drawer']) {
          renderCartDrawer(data.sections['cart-drawer']);
        } else {
          return refreshCartDrawer().then(function () { openCart(); });
        }
        openCart();
      })
      .catch(function (err) {
        toast(err.message || theme.strings.error, true);
      })
      .finally(function () {
        if (button) { button.classList.remove('is-loading'); button.disabled = false; }
      });
  }

  function changeLine(line, quantity) {
    if (cartDrawer) cartDrawer.classList.add('is-updating');
    return fetch(theme.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: ['cart-drawer'], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status && data.status !== 200) throw new Error(data.description || data.message);
        if (data.sections) renderCartDrawer(data.sections['cart-drawer']);
        else return refreshCartDrawer();
      })
      .catch(function (err) { toast(err.message || theme.strings.error, true); })
      .finally(function () { if (cartDrawer) cartDrawer.classList.remove('is-updating'); });
  }

  function initCart() {
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-cart-toggle]');
      if (toggle && theme.cartType !== 'page' && cartDrawer) {
        e.preventDefault();
        openCart();
        return;
      }
      var qtyBtn = e.target.closest('[data-cart-qty]');
      if (qtyBtn) {
        e.preventDefault();
        changeLine(parseInt(qtyBtn.dataset.cartQty, 10), Math.max(0, parseInt(qtyBtn.dataset.qty, 10)));
        return;
      }
      var quick = e.target.closest('[data-quick-add]');
      if (quick) {
        e.preventDefault();
        var fd = new FormData();
        fd.append('id', quick.dataset.quickAdd);
        fd.append('quantity', 1);
        addToCart(fd, quick);
      }
    });

    // Cart note (drawer)
    document.addEventListener('change', function (e) {
      if (e.target.matches('[data-cart-note]')) {
        fetch(theme.routes.cartUpdate, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: e.target.value })
        });
      }
    });

    // Product forms
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-type="add-to-cart-form"]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[data-atc]');
      var err = form.querySelector('[data-form-error]');
      if (err) err.hidden = true;
      addToCart(new FormData(form), btn).then(function () {
        if (btn) {
          btn.classList.add('is-added');
          setTimeout(function () { btn.classList.remove('is-added'); }, 1500);
        }
      });
    });

    // Cart page quantity: auto-update
    var cartForm = $('#CartForm');
    if (cartForm) {
      cartForm.addEventListener('change', debounce(function (e) {
        var input = e.target.closest('[data-cart-page-qty]');
        if (!input) return;
        cartForm.closest('[data-cart-page]').style.opacity = '.5';
        fetch(theme.routes.cartChange, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: parseInt(input.dataset.cartPageQty, 10), quantity: Math.max(0, parseInt(input.value, 10) || 0) })
        }).then(function () { window.location.reload(); });
      }, 400));
    }
  }

  /* ------------------------------------------------------- Quantity inputs */
  function initQty() {
    document.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-qty-minus]');
      var plus = e.target.closest('[data-qty-plus]');
      if (!minus && !plus) return;
      var wrap = (minus || plus).closest('[data-qty-input]');
      var input = wrap && wrap.querySelector('input');
      if (!input) return;
      var min = parseInt(input.min, 10);
      if (isNaN(min)) min = 1;
      var val = parseInt(input.value, 10) || min;
      input.value = Math.max(min, val + (plus ? 1 : -1));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* --------------------------------------------------------------- Sliders */
  function initSliders() {
    $$('[data-slider]').forEach(function (slider) {
      var track = $('[data-slider-track]', slider);
      var slides = $$('[data-slide]', slider);
      var dotsWrap = $('[data-slider-dots]', slider);
      if (!track || !slides.length) return;
      var index = 0;
      var dots = [];

      if (dotsWrap && slides.length > 1) {
        slides.forEach(function (_, i) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'hero__dot';
          d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          d.addEventListener('click', function () { goTo(i); restart(); });
          dotsWrap.appendChild(d);
          dots.push(d);
        });
      }

      function setActive(i) {
        index = i;
        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      }
      function goTo(i) {
        i = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
        setActive(i);
      }
      setActive(0);

      track.addEventListener('scroll', debounce(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== index && slides[i]) setActive(i);
      }, 80), { passive: true });

      var prev = $('[data-slider-prev]', slider), next = $('[data-slider-next]', slider);
      if (prev) prev.addEventListener('click', function () { goTo(index - 1); restart(); });
      if (next) next.addEventListener('click', function () { goTo(index + 1); restart(); });

      var timer = null;
      var autoplay = slider.dataset.autoplay === 'true' && slides.length > 1;
      var interval = parseInt(slider.dataset.interval, 10) || 6000;
      function start() { if (autoplay) timer = setInterval(function () { goTo(index + 1); }, interval); }
      function stop() { clearInterval(timer); }
      function restart() { stop(); start(); }
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      slider.addEventListener('focusin', stop);
      start();
    });
  }

  // Horizontal scroll rows (product sliders, testimonials)
  function initScrollRows() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-row-prev], [data-row-next]');
      if (!btn) return;
      var section = btn.closest('section') || document;
      var rows = $$('[data-scroll-row]', section).filter(function (r) { return r.offsetParent !== null; });
      var row = rows[0];
      if (!row) return;
      var dir = btn.hasAttribute('data-row-next') ? 1 : -1;
      row.scrollBy({ left: dir * row.clientWidth * 0.8, behavior: 'smooth' });
    });
  }

  /* ------------------------------------------------------------------ Tabs */
  function initTabs() {
    document.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-tab]');
      if (!tab) return;
      var wrap = tab.closest('[data-tabs]');
      $$('[data-tab]', wrap).forEach(function (t) {
        t.classList.toggle('is-active', t === tab);
        t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
      });
      $$('[data-tab-panel]', wrap).forEach(function (p) {
        var active = p.dataset.tabPanel === tab.dataset.tab;
        p.classList.toggle('is-active', active);
        if (active) $$('.reveal', p).forEach(function (r) { r.classList.add('is-revealed'); });
      });
    });
  }

  /* ------------------------------------------------------------- Countdown */
  function initCountdowns() {
    $$('[data-countdown]').forEach(function (el) {
      var raw = (el.dataset.countdown || '').trim().replace(' ', 'T');
      var end = new Date(raw).getTime();
      if (isNaN(end)) { el.hidden = true; return; }
      var d = $('[data-cd-days]', el), h = $('[data-cd-hours]', el), m = $('[data-cd-mins]', el), s = $('[data-cd-secs]', el);
      var ended = el.parentNode.querySelector('[data-cd-ended]');
      var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) {
          el.hidden = true;
          if (ended) ended.hidden = false;
          clearInterval(timer);
          return;
        }
        d.textContent = pad(Math.floor(diff / 86400000));
        h.textContent = pad(Math.floor((diff % 86400000) / 3600000));
        m.textContent = pad(Math.floor((diff % 3600000) / 60000));
        s.textContent = pad(Math.floor((diff % 60000) / 1000));
      }
      var timer = setInterval(tick, 1000);
      tick();
    });
  }

  /* -------------------------------------------------------- Copy to clipboard */
  function initCopy() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-copy]');
      if (!btn) return;
      var text = btn.dataset.copy;
      var done = function () { toast('Copied: ' + text); };
      if (navigator.clipboard) navigator.clipboard.writeText(text).then(done, done);
      else {
        var ta = document.createElement('textarea');
        ta.value = text; document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); } catch (err) {}
        ta.remove(); done();
      }
    });
  }

  /* ---------------------------------------------------------- Modals/popup */
  function closeModals() {
    $$('[data-modal]:not([hidden])').forEach(function (m) { m.hidden = true; });
    var popup = $('[data-popup]:not([hidden])');
    if (popup) closePopup(popup);
    document.body.classList.remove('no-scroll');
  }
  function closePopup(popup) {
    popup.hidden = true;
    document.body.classList.remove('no-scroll');
    try { localStorage.setItem('soulmatesly_popup_seen', Date.now()); } catch (e) {}
  }
  function initModals() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-modal-open]');
      if (opener) {
        var m = document.getElementById(opener.dataset.modalOpen);
        if (m) { m.hidden = false; document.body.classList.add('no-scroll'); }
        return;
      }
      if (e.target.closest('[data-modal-close]')) {
        e.target.closest('[data-modal]').hidden = true;
        document.body.classList.remove('no-scroll');
      }
      if (e.target.closest('[data-popup-close]')) closePopup(e.target.closest('[data-popup]'));
    });

    var popup = $('[data-popup]');
    if (!popup) return;
    var hasPosted = popup.querySelector('.form-success') || /customer_posted=true/.test(location.search) || /#PopupNewsletter/.test(location.href);
    if (hasPosted && popup.querySelector('.form-success')) {
      popup.hidden = false;
      return;
    }
    if (popup.dataset.designMode === 'true') return;
    var seen = null;
    try { seen = localStorage.getItem('soulmatesly_popup_seen'); } catch (e) {}
    if (seen && Date.now() - parseInt(seen, 10) < 1000 * 60 * 60 * 24 * 7) return;
    setTimeout(function () {
      if (!openDrawerEl) { popup.hidden = false; document.body.classList.add('no-scroll'); }
    }, (parseInt(popup.dataset.delay, 10) || 8) * 1000);
  }

  /* ---------------------------------------------------------------- Product */
  function initProduct(section) {
    var jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var inventory = {};
    try { inventory = JSON.parse($('[data-inventory-json]', section).textContent); } catch (e) {}
    var picker = $('[data-variant-picker]', section);
    var idInput = $('[data-variant-id]', section);
    var atc = $('[data-atc]', section);
    var atcText = $('[data-atc-text]', section);
    var stickyBtn = $('[data-sticky-btn]', section);
    var stickyPrice = $('[data-sticky-price]', section);
    var stickyVariant = $('[data-sticky-variant]', section);
    var priceWrap = $('[data-price-wrapper]', section);

    /* Gallery */
    var track = $('[data-gallery-track]', section);
    var slides = $$('[data-gallery-slide]', section);
    var thumbs = $$('[data-thumb]', section);
    var counter = $('[data-gallery-index]', section);
    var current = 0;

    function setGallery(i, scroll) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      if (scroll !== false && track) track.scrollTo({ left: slides[current].offsetLeft, behavior: 'smooth' });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === current); });
      if (thumbs[current]) thumbs[current].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      if (counter) counter.textContent = current + 1;
    }
    function showMedia(mediaId) {
      slides.forEach(function (s, n) { if (String(s.dataset.mediaId) === String(mediaId)) setGallery(n); });
    }
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { setGallery(n); }); });
    var gp = $('[data-gallery-prev]', section), gn = $('[data-gallery-next]', section);
    if (gp) gp.addEventListener('click', function () { setGallery(current - 1); });
    if (gn) gn.addEventListener('click', function () { setGallery(current + 1); });
    if (track) {
      track.addEventListener('scroll', debounce(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current) setGallery(i, false);
      }, 80), { passive: true });
      // Start on the variant's featured media
      var activeSlide = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
      if (activeSlide > 0) setTimeout(function () { track.scrollLeft = slides[activeSlide].offsetLeft; setGallery(activeSlide, false); }, 50);
    }

    /* Lightbox */
    var lightbox = $('[data-lightbox]', section);
    if (lightbox) {
      section.addEventListener('click', function (e) {
        var z = e.target.closest('[data-zoom]');
        if (z) {
          $('[data-lightbox-img]', lightbox).src = z.dataset.zoom;
          lightbox.hidden = false;
        }
      });
      lightbox.addEventListener('click', function () { lightbox.hidden = true; });
    }

    /* Variants */
    function selectedOptions() {
      return $$('fieldset[data-option-index]', picker).map(function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }
    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function markAvailability(opts) {
      $$('fieldset[data-option-index]', picker).forEach(function (fs) {
        var idx = parseInt(fs.dataset.optionIndex, 10);
        $$('input[data-option-input]', fs).forEach(function (input) {
          var test = opts.slice();
          test[idx] = input.value;
          var available = product.variants.some(function (v) {
            return v.available && v.options.every(function (o, i) { return i === idx ? o === input.value : (i > idx ? true : o === test[i]); });
          });
          var label = fs.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !available);
        });
      });
    }
    function updatePrice(variant) {
      if (!priceWrap) return;
      var cur = $('[data-price]', priceWrap);
      var cmp = $('[data-compare-price]', priceWrap);
      var save = $('[data-price-save]', priceWrap);
      cur.textContent = formatMoney(variant.price);
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      priceWrap.classList.toggle('price--on-sale', !!onSale);
      cmp.hidden = !onSale;
      save.hidden = !onSale;
      if (onSale) {
        cmp.textContent = formatMoney(variant.compare_at_price);
        save.textContent = 'Save ' + Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%';
      }
      var badge = $('[data-gallery-badge]', section);
      if (badge) {
        badge.hidden = !onSale;
        if (onSale) badge.textContent = '-' + Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%';
      }
    }
    function updateStock(variant) {
      var stock = $('[data-stock]', section);
      if (!stock) return;
      var low = $('[data-stock-low]', stock), inStock = $('[data-stock-in]', stock);
      var threshold = parseInt(stock.dataset.threshold, 10) || 10;
      var inv = variant ? inventory[variant.id] : null;
      var isLow = variant && variant.available && inv && inv.tracked && inv.qty > 0 && inv.qty <= threshold;
      low.hidden = !isLow;
      if (isLow) $('[data-stock-qty]', low).textContent = inv.qty;
      inStock.hidden = !(variant && variant.available) || isLow;
    }
    function updateButtons(variant) {
      var label, disabled;
      if (!variant) { label = theme.strings.unavailable; disabled = true; }
      else if (!variant.available) { label = theme.strings.soldOut; disabled = true; }
      else { label = theme.strings.addToCart; disabled = false; }
      if (atc) { atc.disabled = disabled; atcText.textContent = label; }
      if (stickyBtn) { stickyBtn.disabled = disabled; stickyBtn.textContent = label; }
      var dyn = $('.shopify-payment-button', section);
      if (dyn) dyn.style.display = disabled ? 'none' : '';
    }

    function onChange() {
      var opts = selectedOptions();
      var variant = findVariant(opts);
      $$('fieldset[data-option-index]', picker).forEach(function (fs, i) {
        var sel = fs.querySelector('[data-selected-value]');
        if (sel) sel.textContent = opts[i] || '';
      });
      markAvailability(opts);
      updateButtons(variant);
      updateStock(variant);
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      updatePrice(variant);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      if (stickyVariant) stickyVariant.textContent = variant.title;
      if (variant.featured_media) showMedia(variant.featured_media.id);
      if (section.dataset.productUrl && window.history.replaceState) {
        window.history.replaceState({}, '', section.dataset.productUrl + '?variant=' + variant.id);
      }
    }

    if (picker) {
      picker.addEventListener('change', onChange);
      markAvailability(selectedOptions());
    }

    /* Sticky ATC */
    var sticky = $('[data-sticky-atc]', section);
    var mainAtc = $('[data-main-atc-wrap]', section);
    if (sticky && mainAtc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          document.body.classList.toggle('sticky-visible', show);
        });
      });
      io.observe(mainAtc);
    }
  }

  /* -------------------------------------------------- Product recommendations */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      if (el.querySelector('.product-grid')) return;
      fetch(el.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim()) {
            el.innerHTML = fresh.innerHTML;
            observeReveals(el);
          }
        })
        .catch(function () {});
    });
  }

  /* ----------------------------------------------------- Collection filters */
  function initFilters() {
    var form = $('[data-filter-form]');
    var sort = $('[data-filter-sort]');
    function submit() {
      var params = new URLSearchParams();
      if (form) {
        new FormData(form).forEach(function (value, key) {
          if (value !== '') params.append(key, value);
        });
      }
      if (sort) params.set('sort_by', sort.value);
      var section = $('[data-collection]');
      if (section) section.classList.add('is-loading');
      window.location.search = params.toString();
    }
    if (form) {
      var isDesktop = function () { return window.matchMedia('(min-width: 990px)').matches; };
      form.addEventListener('change', debounce(function (e) {
        if (e.target.type === 'number' && !isDesktop()) return;
        if (isDesktop()) submit();
      }, 500));
      form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
      var footerSubmit = document.querySelector('button[form="FilterForm"]');
      if (footerSubmit) footerSubmit.addEventListener('click', function (e) { e.preventDefault(); submit(); });
    }
    if (sort) sort.addEventListener('change', submit);
  }

  /* --------------------------------------------------------- Scroll reveal */
  var revealObserver = null;
  function observeReveals(ctx) {
    var els = $$('.reveal:not(.is-revealed)', ctx);
    if (!theme.animations || !revealObserver || (window.Shopify && window.Shopify.designMode)) {
      els.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }
    els.forEach(function (el) { revealObserver.observe(el); });
  }
  function initReveal() {
    if ('IntersectionObserver' in window) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    observeReveals(document);
  }

  /* ----------------------------------------------------------- Back to top */
  function initBackToTop() {
    var btn = $('[data-back-to-top]');
    if (!btn) return;
    window.addEventListener('scroll', function () {
      btn.classList.toggle('is-visible', window.scrollY > 700);
    }, { passive: true });
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* ----------------------------------------------------------------- Video */
  function initVideo() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-video-play]');
      if (!btn) return;
      var id = btn.dataset.id, type = btn.dataset.type, src;
      if (type === 'youtube') src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
      else src = 'https://player.vimeo.com/video/' + id + '?autoplay=1';
      var iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.title = 'Video';
      btn.replaceWith(iframe);
    });
  }

  /* ----------------------------------------------------------------- Login */
  function initLogin() {
    var login = $('#LoginPanel'), recover = $('#RecoverPanel');
    if (!login || !recover) return;
    function show(isRecover) { login.hidden = isRecover; recover.hidden = !isRecover; }
    if (location.hash === '#recover' || recover.querySelector('.form-success, .form-error')) show(true);
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-toggle-recover]')) {
        e.preventDefault();
        show(recover.hidden);
      }
    });
  }

  /* --------------------------------------------------------- Theme editor */
  function initEditor() {
    if (!(window.Shopify && window.Shopify.designMode)) return;
    document.addEventListener('shopify:section:load', function (e) {
      hoistMenuDrawer();
      observeReveals(e.target);
      initSliders();
      initCountdowns();
      var p = e.target.querySelector('[data-product-section]');
      if (p) initProduct(p);
    });
    document.addEventListener('shopify:block:select', function (e) {
      var slide = e.target.closest('[data-slide]');
      if (slide) {
        var track = slide.parentNode;
        track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
    });
    document.addEventListener('shopify:section:select', function (e) {
      if (e.target.querySelector('[data-cart-drawer]')) openDrawer($('[data-cart-drawer]'));
      var popup = e.target.querySelector('[data-popup]');
      if (popup) popup.hidden = false;
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      var popup = e.target.querySelector('[data-popup]');
      if (popup) popup.hidden = true;
    });
  }

  /* ------------------------------------------------------------------ Init */
  function init() {
    initHeader();
    initAnnouncement();
    initSearch();
    initCart();
    initQty();
    initSliders();
    initScrollRows();
    initTabs();
    initCountdowns();
    initCopy();
    initModals();
    $$('[data-product-section]').forEach(initProduct);
    initRecommendations();
    initFilters();
    initReveal();
    initBackToTop();
    initVideo();
    initLogin();
    initEditor();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
